import { isNil } from "@hopper-ui/components";
import { MixpanelEventName, MixpanelProperty } from "@sg-protect/shell";
import type { DOMEventTelemetryHandler } from "./domEventTracker.ts";
import { findRadioText, getModalInformation, getTelemetryName } from "./utils.ts";

export const radioChangeHandler: DOMEventTelemetryHandler<"change"> = {
    isHandling: evt => {
        if (isNil(evt.target) || (evt.target as HTMLElement).tagName !== "INPUT" || isHopperRadio(evt.target)) {
            return false;
        }

        return (evt.target as HTMLInputElement).type === "radio";
    },
    handleEvent: (evt, onEvent) => {
        const radio = evt.target as HTMLInputElement;
        const text = findRadioText(radio);
        const modalInformation = getModalInformation(radio);

        void onEvent(MixpanelEventName.RadioChanged, {
            [MixpanelProperty.Name]: text,
            [MixpanelProperty.IsChecked]: radio.checked,
            [MixpanelProperty.Modal]: modalInformation
        });
    }
};

export const hopperRadioChangeHandler: DOMEventTelemetryHandler<"click"> = {
    isHandling: evt => !isNil(evt.target) && isHopperRadio(evt.target),
    handleEvent: (evt, onEvent) => {
        const target = evt.target as HTMLInputElement;
        const parent = target.closest("label");
        const label = parent?.querySelector(".hop-Text") as HTMLElement | null;
        const text = label ? getTelemetryName(label) : "Redacted";
        const modalInformation = getModalInformation(target);

        void onEvent(MixpanelEventName.RadioChanged, {
            [MixpanelProperty.Name]: text,
            [MixpanelProperty.IsChecked]: true,
            [MixpanelProperty.Modal]: modalInformation
        });
    }
};

function isHopperRadio(eventTarget: EventTarget): boolean {
    return (eventTarget as HTMLElement).closest("label")?.className.includes("hop-Radio") ?? false;
}
